import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CartContextProvider } from '@nexus/fff-cart';
import reduce from 'lodash/reduce';

import useCartData from 'hooks/useCartData';
import { receiveUpdateCart as receiveUpdateCartAction } from 'services/actions/cartActions';
import { receiveCartProducts as receiveCartProductsAction } from 'services/actions/productsActions';
import {
  openInviteModal as openInviteModalAction,
  receiveTeamCarts as receiveTeamCartsAction,
} from 'services/actions/socialEcommActions';
import { selectIsCampaignOpen } from 'services/reducers/campaignReducer';
import withVersion from 'HOC/withVersion/withVersion';
import { VERSION } from 'utils/campaign';

const CartContext = ({
  version,
  cartDetails,
  account,
  products,
  variants,
  subscribableProducts,
  children,
  receiveUpdateCart,
  teamId,
  openInviteModal,
  receiveTeamCarts,
  socialAvatars,
  teamCartData,
  receiveCartProducts,
  campaignIsOpen,
}) => {
  const history = useHistory();
  const { prevPurchasedVariantQuantities, variantCadenceTypes } = cartDetails;
  const variantsAndSubscriptions = reduce(
    variants,
    (result, value, key) => {
      // if variant id is in variantCadenceTypes it is subscribable
      if (variantCadenceTypes[key] && subscribableProducts[key]) {
        const { retailPrice, salePrice, soldOut, cartLimit, inventoryLimit } =
          subscribableProducts[key];
        // replace fields from subcribableProducts
        return {
          ...result,
          [key]: {
            ...value,
            price: retailPrice,
            salePrice,
            soldOut,
            cartLimit,
            inventoryLimit,
          },
        };
      }
      return {
        ...result,
        [key]: value,
      };
    },
    {}
  );
  const cartData = useCartData(
    cartDetails,
    products,
    variantsAndSubscriptions,
    prevPurchasedVariantQuantities
  );
  const isEditPage = version === VERSION.edit;
  const isSalePage =
    version === VERSION['add-ons'] || isEditPage || version === VERSION.shop;
  const isLiveSalePage = isSalePage && campaignIsOpen;

  const onClickProduct = (props) => {
    history.push({
      ...props,
    });
  };

  return (
    <CartContextProvider
      cartData={isLiveSalePage && cartData}
      account={account}
      receiveUpdateCart={isSalePage && receiveUpdateCart}
      onClickProduct={onClickProduct}
      teamId={teamId}
      openInviteModal={openInviteModal}
      receiveTeamCarts={isEditPage && receiveTeamCarts}
      socialAvatars={isEditPage && socialAvatars}
      teamCartData={isEditPage && teamCartData}
      receiveCartProducts={isLiveSalePage && receiveCartProducts}
    >
      {children}
    </CartContextProvider>
  );
};

const mapStateToProps = (state) => ({
  cartDetails: state.cartState,
  account: state.userState,
  products: state.productsState.products,
  variants: state.productsState.variants,
  subscribableProducts: state.productsState.subscribableProducts,
  teamId: state.socialEcommState.team.teamId,
  socialAvatars: state.socialEcommState.socialAvatars,
  teamCartData: state.socialEcommState.teamCart,
  campaignIsOpen: selectIsCampaignOpen(state),
});

const mapDispatchToProps = {
  receiveUpdateCart: receiveUpdateCartAction,
  openInviteModal: openInviteModalAction,
  receiveTeamCarts: receiveTeamCartsAction,
  receiveCartProducts: receiveCartProductsAction,
};

export default compose(
  withVersion,
  connect(mapStateToProps, mapDispatchToProps)
)(CartContext);
